import Vue from 'vue';

/** Event bus for sending SSID events. */
const SsidEventBus = new Vue();

export default SsidEventBus;
